import { render, staticRenderFns } from "./AsideComponet.vue?vue&type=template&id=5503a055&scoped=true&"
import script from "./AsideComponet.vue?vue&type=script&lang=js&"
export * from "./AsideComponet.vue?vue&type=script&lang=js&"
import style0 from "./AsideComponet.vue?vue&type=style&index=0&id=5503a055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5503a055",
  null
  
)

export default component.exports